module.exports = __webpack_public_path__ + "img/blanket_5.dae85df7.png";